<template>
    <div>
        hwer ea are
    </div>
</template>
<script>
export default {
  name: 'Heat-Map',
  data () {
    return {
      pickrGeoData: {}

    }
  },
  mounted () {
    this.getMixCampaignDetails()
  },
  methods: {
    getMixCampaignDetails () {
      this.$store.dispatch('getMixCampaignDetails', this.$route.params.picklId).then((response) => {
        console.log(response)
        this.mixCampaignDetails = response.body.body
      })
    }
  }
}
</script>
